// extracted by mini-css-extract-plugin
module.exports = {"required":"SubscriptionDetail_required_3z5UV"};